var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "edit-registration",
      attrs: { "data-cy-form-view-type": _vm.viewType },
    },
    [
      _vm.readOnly
        ? _c(
            "div",
            {
              class: `info-container attention`,
              attrs: { "data-cy": "preview-registration-notification" },
            },
            [
              _c("vwc-icon", {
                class: `icon info-icon`,
                attrs: { type: `info` },
              }),
              _c("div", { staticClass: "content" }, [
                _c("h5", {
                  staticClass: "content-header",
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.$t(
                        "smsRegistrations.statusPage.previewRegistrationInfoBoxTitle"
                      )
                    ),
                  },
                }),
                _vm.isVoluntaryEditEnabled
                  ? _c("div", {
                      staticClass: "content-text",
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.$t(
                            "smsRegistrations.statusPage.previewRegistrationInfoBoxText"
                          )
                        ),
                      },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.handleStatusInfoClick.apply(
                            null,
                            arguments
                          )
                        },
                      },
                    })
                  : _vm._e(),
              ]),
            ],
            1
          )
        : _vm._e(),
      _c(
        "cd-modal",
        {
          staticClass: "modal",
          attrs: {
            "data-cy": "important-update-modal",
            title: "Important Update",
            large: true,
            canCancel: false,
            okText: "Ok, Got it",
            visible: _vm.isModalVisible,
            "no-footer": true,
          },
          on: {
            close: function ($event) {
              _vm.isModalVisible = false
            },
            confirm: function ($event) {
              _vm.isModalVisible = false
            },
          },
        },
        [
          _c("vwc-icon", {
            staticClass: "modal-icon",
            attrs: { type: "megaphone-line" },
          }),
          _c("img", {
            staticClass: "image",
            attrs: {
              src: require("@/assets/updatesRequiredModal.png"),
              alt: "Image",
            },
          }),
          _c("p", {
            staticClass: "modal-text",
            domProps: {
              innerHTML: _vm._s(
                _vm.$t("smsRegistrations.updatesRequiredModalText")
              ),
            },
          }),
          _c(
            "footer",
            { staticClass: "footer" },
            [
              _c("cd-button", {
                attrs: {
                  id: "cancel",
                  connotation: "primary",
                  layout: "filled",
                  label: "Ok, Got it",
                },
                on: {
                  click: function ($event) {
                    _vm.isModalVisible = false
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "register-step-form",
        {
          attrs: {
            steps: _vm.steps,
            "current-step": _vm.currentStep,
            "next-button-disabled": _vm.isNextDisabled,
            registerInProgress: _vm.registerInProgress,
            "registered-type-name": _vm.stepFormType,
            "cancel-button": !_vm.readOnly,
            "is-updates-required": _vm.isUpdatesRequired,
            "read-only": _vm.readOnly,
          },
          on: {
            nextStep: function ($event) {
              _vm.currentStep++
            },
            previousStep: function ($event) {
              _vm.currentStep--
            },
            registerAndPay: _vm.submitForm,
            cancel: _vm.closeForm,
          },
        },
        [
          _c("general-details", {
            attrs: {
              slot: "step-body-1",
              "registration-details": _vm.registrationDetails,
              "is-edit-view": true,
              "read-only": _vm.readOnly,
            },
            on: { pageValidityChange: _vm.onGeneralDetailsValid },
            slot: "step-body-1",
            model: {
              value: _vm.registrationDetails,
              callback: function ($$v) {
                _vm.registrationDetails = $$v
              },
              expression: "registrationDetails",
            },
          }),
          _c("messaging-description", {
            attrs: {
              slot: "step-body-2",
              "company-name": _vm.registrationDetails.displayName,
              "company-url": _vm.registrationDetails.website,
              "messaging-description-data": _vm.messagingDescriptionData,
              "read-only": _vm.readOnly,
            },
            on: { pageValidityChange: _vm.onMessagingDescriptionValid },
            slot: "step-body-2",
            model: {
              value: _vm.messagingDescriptionData,
              callback: function ($$v) {
                _vm.messagingDescriptionData = $$v
              },
              expression: "messagingDescriptionData",
            },
          }),
          _c("message-content-type", {
            attrs: {
              slot: "step-body-3",
              "message-content-details": _vm.messageContentDetails,
              "company-name": _vm.registrationDetails.displayName,
              "read-only": _vm.readOnly,
            },
            on: { pageValidityChange: _vm.onMessageContentValid },
            slot: "step-body-3",
            model: {
              value: _vm.messageContentDetails,
              callback: function ($$v) {
                _vm.messageContentDetails = $$v
              },
              expression: "messageContentDetails",
            },
          }),
          _vm.readOnly
            ? _c("cd-button", {
                staticClass: "close-preview-button",
                attrs: {
                  slot: "footer-buttons",
                  "data-cy": "close-preview-button",
                  layout: "outlined",
                  connotation: "primary",
                  label: _vm.$t(
                    "smsRegistrations.statusPage.closeRegistrationDetailsButton"
                  ),
                },
                on: { click: _vm.closeForm },
                slot: "footer-buttons",
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }